module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ca2a88ac05b09810353e810b9638f884.png";